import { render, staticRenderFns } from "./completion.vue?vue&type=template&id=dabc2f22&scoped=true"
import script from "./completion.vue?vue&type=script&lang=js"
export * from "./completion.vue?vue&type=script&lang=js"
import style0 from "./completion.vue?vue&type=style&index=0&id=dabc2f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabc2f22",
  null
  
)

export default component.exports